import React from 'react'

// Generic bordered card chrome used by every Overview chart/section block.
const OverviewCard = ({
    title,
    subtitle,
    headerRight,
    children,
    className
}) => {
    return (
        <div
            className={`border border-[#e9e9ea] bg-white p-5 flex flex-col ${
                className || ''
            }`}
        >
            {(title || headerRight) && (
                <div className='flex items-start justify-between gap-2 mb-5'>
                    <div>
                        {title && (
                            <h4 className='regular-14 weight-500 text-[#21242b]'>
                                {title}
                            </h4>
                        )}
                        {subtitle && (
                            <p className='regular-12 text-[#999a9d] mt-0.5'>
                                {subtitle}
                            </p>
                        )}
                    </div>
                    {headerRight}
                </div>
            )}
            <div className='flex-1'>{children}</div>
        </div>
    )
}

export default OverviewCard
